export default __webpack_public_path__ + "static/poster-ac0ebd7a65ec39dc7ed71bf59ac78ce8.jpg";